import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state';
import { Action, State, Selector, StateContext } from '@ngxs/store';
import { AcceleratorCatalogService } from 'src/app/components/home/accelerator-status/accelerator.service';
import { AcceleratorStatusRefresh } from './accelerator-status.action';
import { utils } from 'src/app/modules/libs/utils';
import { AcceleratorStatus } from '../accelerator.service';
import { readStatusSnapshot, writeStatusSnapshot } from '../../status-snapshot-cache';

const ACCELERATOR_STATUS_SNAPSHOT_KEY = 'home:accelerator-status:snapshot';

export class AcceleratorStatusStateModel {
  acceleratorStatus: AcceleratorStatus[] | undefined;
  loading!: boolean;
  // Cached values do not mark the live startup refresh complete.
  loaded!: boolean;
}

@State<AcceleratorStatusStateModel>({
  name: 'AcceleratorStatus',
  defaults: {
    acceleratorStatus: [],
    loading: false,
    loaded: false,
  }
})
@Injectable()
export class AcceleratorStatusState extends BaseState {
  constructor(
    protected override injector: Injector,
    private acceleratorService: AcceleratorCatalogService
  ) { super(injector); }

  @Selector()
  static read(state: AcceleratorStatusStateModel) {
    return state.acceleratorStatus;
  }

  @Action(AcceleratorStatusRefresh)
  refresh({ getState, patchState }: StateContext<AcceleratorStatusStateModel>) {
    patchState({ loading: true, loaded: false });

    if (!getState().acceleratorStatus?.length) {
      const snapshot = readStatusSnapshot<AcceleratorStatus[]>(ACCELERATOR_STATUS_SNAPSHOT_KEY);
      if (snapshot?.length) patchState({ acceleratorStatus: snapshot });
    }

    this.acceleratorService.getAcceleratorStatus().toPromise().then(data => {
      patchState({ acceleratorStatus: utils.cloneDeep(data), loading: false, loaded: true });
      writeStatusSnapshot(ACCELERATOR_STATUS_SNAPSHOT_KEY, data);
    }).catch(error => {
      patchState({ loading: false });
      console.error(error);
    });
  }

}
